// hooks
import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { useMapContext } from 'Map/context/MapProvider'
// components
import Typography from '@material-ui/core/Typography'
import Card from 'common/Card'
//
import { strings } from 'strings'

const Measurments = () => {
  const { pathname } = useLocation()

  const { mapRef, positions, setLinePositions } = useMapContext()

  useEffect(() => {
    const mapContainer = mapRef.current?.getContainer()

    if (/measurement/i.test(pathname)) if (mapContainer) mapContainer.style.cursor = 'crosshair'

    return () => {
      if (mapContainer) mapContainer.style.cursor = 'default'
      setLinePositions([])
    }
  }, [pathname])

  return (
    <Card title={strings.measure} style={{ height: '4.5rem' }}>
      {positions.length === 2 && (
        <div style={{ display: 'flex' }}>
          <Typography>{strings.distance}:</Typography>
          <Typography style={{ direction: 'ltr', marginRight: 10 }}>
            {(positions[0].distanceTo(positions[1]) / 1000).toFixed(3)} km
          </Typography>
        </div>
      )}
    </Card>
  )
}

export default Measurments
